<!--<div [@routeAnimations]="prepareRoute(outlet)">-->
<div>
  <router-outlet #outlet="outlet"></router-outlet>
</div>